import request, { FormDataHeader } from '@/utils/request'
import {
  ImagesQuery,
  ImageInfo,
  GetCrmAreaInfoQuery,
  GetCrmAreaInfoResultItem,
} from '@/types/public'

export function UploadImages(images: FormData): Promise<string[]> {
  console.log('images', images)
  return request.post('/api/agri/common/images', images, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function GetImagesInfo(query: ImagesQuery): Promise<ImageInfo[]> {
  return request.post('/api/agri/common/images/urls', query)
}

export function GetCrmQiniuToken(): Promise<{
  key_prefix: string
  token: string
  url: string
  use_cdn_domain: boolean
}> {
  return request.get('/crm-common/qiniu/uptoken')
}

export function getRepairQiniuToken(): Promise<{
  uptoken: string
}> {
  return request.get(`/api-invoice/common/qiniu/oauth_up_token`)
}

export function qiniuKeyConvert(param: FormData): Promise<{
  [key: string]: string
}> {
  return request.post(`/api-invoice/resource/home/qiniu_key_convert`, param, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// 综合办公系统文件上传
export function uploadFileToIntegratedSystem(param: FormData) {
  return request
    .post(`/api-backstage/sp/upload_file`, param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((data) => {
      return {
        key: data,
      }
    })
}

export function createSupervisionReport(param: {
  // 创建监督举报记录
  role: string // 角色
  phone: string // 联系电话
  feedback_phone: string // 反馈电话
  complaint_object: string // 举报对象
  position: string // 举报对象岗位
  complaint_content: string // 投诉内容
  annex_list: Array<{
    uri: string // 阿里云uri
    file_name: string // 文件名称
    suffix: string // 后缀
  }>
}): Promise<void> {
  return request.post('/api-backstage/sp/report', param)
}

export function getCrmAreaInfo(params?: GetCrmAreaInfoQuery): Promise<GetCrmAreaInfoResultItem[]> {
  return request.get(`/crm-common/area/areas`, {
    params: {
      ...params,
      location_area: 1,
    },
  })
}

// 生成短链接
export function getXaShortLink(params: { url: string }): Promise<{
  key: string
}> {
  return request.post('/api-sl/shorten', params, {
    headers: FormDataHeader,
  })
}

// 生成小程序URL Scheme码
export function generateWechatScheme(params: {
  expire_interval?: number
  expire_time?: number
  expire_type?: 0 | 1
  jump_wxa: {
    env_version?: 'release' | 'trial' | 'develop'
    path?: string
    query?: string
  }
}): Promise<{
  errcode: number
  errmsg: string
  openlink: string
}> {
  return request.post('/api/other/wechat/generate_scheme', params)
}
